<template>
  <div :id="idModal" class="modal fade" tabindex="-1" :aria-labelledby="ariaLabelledBy" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-tamanio">
      <div class="modal-content modal-cuadro p-2" :style="`background-color: ${backgroundColor}`">
        <div class="modal-header border-0 pb-0 d-flex justify-content-between align-items-start">
          <slot name="titulo" />
          <button type="button" class="btn-close close-modal" data-bs-dismiss="modal" aria-label="Close" />
        </div>

        <div class="modal-body me-3">
          <slot name="contenido" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  defineProps({
    idModal: {
      type: String,
      required: true,
    },
    ariaLabelledBy: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: '#F9F7F8',
    },
  });
</script>

<style lang="css" scoped>
  @media (min-width: 1050px) {
    .modal-tamanio {
      max-width: 1000px !important;
    }
  }

  .modal-cuadro {
    border-radius: var(--bs-border-radius-xl);
  }

  .close-modal {
    position: absolute;
    right: 20px;
  }
</style>
